<template>
	<div class="coldcall"
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"	
	>

		<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Объектов найдено: {{this.masObjects_total}}</span>
		</div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="coldcalls"
			/>
		</div> 

		<div class="callsObjects">

			<tabs type="primary" 
				:activeTab="value"
				@change="OnTabChange"
				tabContentClasses="tab-opt"
				centered
				inline
				round	
				v-loading.fullscreen.lock="fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"		
				class="card card-plain">
				<tab-pane :id="'callTable'" >
					<span slot="label" class="tab-label">
						<i class="tab-icon tim-icons icon-align-left-2"></i><span>Список</span>
					</span>

					<ReCallsObjTable :objData="ApiData" @sort="onTableSort" />

				</tab-pane>

				<tab-pane :id="'callTiles'" class=""  
					>
					<span slot="label" class="tab-label">
						<i class="tab-icon tim-icons icon-components"></i><span>Плитка</span>
					</span>
					<div class="card-wrapper">
						<div class="card-wrapper-center row px-3">
							<h3 class="text-center" v-if="ApiData.length==0">Ничего не найдено</h3>	
							<ReCallsObjSmall v-for="obj in ApiData" :key="obj.id" :objData="obj" style="" />
						</div>
					</div>
				</tab-pane>

				<tab-pane :id="'callMap'" class=""  
					>
					<span slot="label" class="tab-label">
						<i class="tab-icon tim-icons icon-map-big"></i><span>Карта</span>
					</span>

					
					<div class="row justify-content-center px-3"  >	
						<div class="col text-center">
							<h3 class=""  v-if="ApiMapData.length==0">Ничего не найдено</h3>		
							<h3 v-if="this.ApiMapData.length < this.masObjects_total">Карта поддерживает вывод ограниченного количества объектов недвижимости. 
								Для сокращения количества объектов воспользуйтесь фильтром.</h3>	
						</div>				
						<ReCallsObjMap  :objData="ApiMapData"/>
					</div>
				</tab-pane>
			</tabs>
		</div>
		
		<Pagination v-if="currentTab != 'callMap'" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)" 
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>	
	</div>
</template>
<script>

import { Table, TableColumn } from 'element-ui';
import { TabPane, Tabs } from 'src/components';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReCallsObjects from 'src/our_components/calls/ReCallsObjects.vue'; 
import {eventEmitter} from "src/plugins/globalComponents.js";
import Pagination from 'src/our_components/RePagination';
import ReCallsObjSmall from 'src/our_components/calls/ReCallsObjSmall.vue';
import ReCallsObjMap from 'src/our_components/calls/ReCallsObjMap.vue'; 
import ReCallsObjTable from 'src/our_components/calls/ReCallsObjTable.vue'; 

export default {
	name: 'coldcall-page',
	components: {
		[Table.name]: Table,
    	[TableColumn.name]: TableColumn,
		TabPane, 
		Tabs,
		// ReCallsObjects,
		ReFilterBtn,
		ReFilter,
		Pagination,
		ReCallsObjSmall,
		ReCallsObjMap,
		ReCallsObjTable,
	},
	props: {
		masObjects: [Array,Object],
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		// value: {
		// 	type: String,
		// 	default: 'callTable', // flat||complex||complexmap  
		// }, 
	},
	data() {
		return {
			fullscreenLoading: false,
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			ApiData: [],
			ApiMapData: [],
			objGetParams:{},
			masObjects_total: 0,
			// count2page: 10,
			currentTab:'callTable',
			localTab:'',
			value:'callTable',
			objSortLoc: {sortProp: 'creationDate', sortOrder: 'descending'},  //objSort:{prop: 'lastUpdateDate', order: 'descending'},
		};
	},
	methods: {
		onTableSort(objSort){
			//console.log('onTableSort');
			this.objSortLoc.sortProp = objSort.prop;
			this.objSortLoc.sortOrder = objSort.order;

			let bFromObj = false;
			if(SGVO.prevRoute != null) 
				if(SGVO.prevRoute.indexOf('/ColdCall/id/')>0) bFromObj = true;

			if(objSort.order != null){
				var queryParams = new URLSearchParams(window.location.search);
				queryParams.set("sortProp", objSort.prop);
				queryParams.set("sortOrder", objSort.order);
				history.replaceState(null, null, "?"+queryParams.toString());
				this.objGetParams = this.$GVO.GetAllGet();
				if(typeof this.objGetParams['p'] != 'undefined' && bFromObj===false){
					delete this.objGetParams['p'];
				}
				if(bFromObj===false) this.OnFilterApply();
			}
		},
		getApiData(){
			//return true;
			//console.log('getApiData');
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('COLD_CALLS.GET',{flt:{...{act:1}, ...filter, ...this.objSortLoc}})
			.then((objApi) => {
				if(objApi.success === true){
					this.ApiData = [];
					this.masObjects_total = 0;
					
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						// this.masObjects_total = objApi.countpage;
						// console.log(objApi);
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		getApiMapData(){
			//return true;
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('COLD_CALLS.GET',{flt:{...{act:1, map:true}, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					this.masObjects_total = 0;
					this.ApiMapData = [];
					if(objApi.data.length > 0){
						this.ApiMapData = objApi.data;	
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }					
					}
				}else{
					this.ApiMapData = [];	
					this.masObjects_total=0;				
				}
			}).catch(errorObjApi => {this.ApiMapData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('COLD_CALLS.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						//console.log(objApi.config[0].elements[objApi.config[0].elements.length-1]);
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){ 
			//console.log('OnFilterApply_caller',new Error().stack);
			// console.log('OnFilterApply',data);

			let bFromObj = false;
			//console.log('OnFilterApply',SGVO.prevRoute);
			if(SGVO.prevRoute != null) 
				if(SGVO.prevRoute.indexOf('/ColdCall/id/')>0) bFromObj = true;
			//console.log('OnFilterApply',bFromObj);

			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined' && bFromObj==false){
				delete this.objGetParams['p'];
			}

			SGVO.prevRoute=null;
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',location.pathname+'?'+strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			if(this.currentTab == 'callMap'){this.getApiMapData();}else{this.ApiMapData = [];this.getApiData();}
			
		},
			
		OnTabChange(strTabId){
			//console.log('OnTabChange',strTabId);
			if(this.currentTab == strTabId) return true;
			this.currentTab = strTabId;
			this.$emit('input', strTabId);
			this.$emit('change', strTabId);

			sessionStorage.setItem('localTab', this.currentTab);
			// console.log(localStorage);

			this.localTab = sessionStorage.getItem('localTab');
			// this.value = this.localTab;
			// console.log(this.localTab);
			
			if(strTabId == 'callMap'){this.getApiMapData();}else{this.ApiMapData = [];this.getApiData();}
		},

		openFullScreen1() {
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 2000);
		},
		
		
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		//this.getApiData();
	},
	created(){
		if (sessionStorage.getItem('localTab')) {
			// console.log(localStorage);
			this.value = sessionStorage.getItem('localTab');
			// console.log(this.value);
		}
	},

};
</script>
<style scoped>
.coldcall >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.coldcall >>> .tab-content {margin-top: 15px;}
.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}

audio.call-audio {
	outline: none;
	border-radius: 2rem;
	background-color: transparent;
	border: 1px solid #01B0E0;
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
figure {margin-bottom: 0px;}

.callsObjects >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.callsObjects >>> .tab-content {margin-top: 15px;}
.callsObjects >>> .form-options .bntGroup > * {width: fit-content;}
/*.coldcall >>> .overflow-overlay {padding-right: 38px!important;}*/

.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}

/*===media===============================*/
@media (max-width: 400px) {
	audio {width: 215px;}
}
@media (max-width: 768px) {
	.flat .row {width: 100%; margin-left: 0px;}
}
@media (max-width: 853px) and (min-width: 768px) {
	audio {width: 230px;}
}

</style>
